// import './App.css';
import React from 'react';
import { Routes, Route, Navigate  } from 'react-router-dom';
import DashboardAdmin from './components/DashboardAdmin/DashboardAdmin';
import ICTData from './components/DashboardAdmin/ICTData/ICTData';
import '@fortawesome/fontawesome-free/css/all.min.css';
import StudyModesTable from './components/DashboardAdmin/ICTData/StudyModesTable';
import ICTDetails from './components/DashboardAdmin/ICTData/ICTDetails';
import ICTFeedbacks from './components/DashboardAdmin/ICTData/ICTFeedbacks';
import LeadsComponent from './components/DashboardAdmin/ICTData/LeadsComponent';
import Learners from './components/DashboardAdmin/ICTData/ICTLearner';
import LearningBundles from './components/DashboardAdmin/ICTData/LearningBundles';
import StudyMaterials from './components/DashboardAdmin/ICTData/StudyMaterials';
import ICTDataInsert from './components/DashboardAdmin/ICTData/subComponents/ICTData/ICTDataInsert';
import LearningModules from './components/DashboardAdmin/ICTData/LearningModules';
import RecordingsManagement from './components/DashboardAdmin/ICTData/RecordingsManagement';
import TrainingCards from './components/DashboardAdmin/ICTData/TrainingCards';
import Dashboard from './components/DashboardAdmin/ICTData/Dashboard';
import FAQManager from './components/DashboardAdmin/ICTData/FAQManager';
import DomainsManager from './components/DashboardAdmin/ICTData/DomainManager';
import EmployeeManager from './components/DashboardAdmin/ICTData/EmployeeManager';
import TrainersManager from './components/DashboardAdmin/ICTData/TrainersManager';
import Accommodations from './components/DashboardAdmin/ICTData/Accommodations';
import TravelData from './components/DashboardAdmin/ICTData/TravelData';
import TourData from './components/DashboardAdmin/ICTData/TourData';
import DCData from './components/DashboardAdmin/ICTData/DCData';
import ICTSalesCard from './components/DashboardAdmin/ICTData/ICTSalesCard';
import ICTSalesCardReceiptPopup from './components/DashboardAdmin/ICTData/subComponents/ictSalesCard/ICTSalesCardReceiptPopup';
import Login from './components/Login';
import ProtectedRoute from "./ProtectedRoute";
import MiscExpenseManager from './components/DashboardAdmin/ICTData/MiscExpenseManager';
import IctEnquiryManager from './components/DashboardAdmin/ICTData/ICTEnquiryManager';
import ICTInvoice from './components/DashboardAdmin/ICTData/ICTInvoice';
import EventsManager from './components/DashboardAdmin/ICTData/EventsManager';
import TestimonialsManager from './components/DashboardAdmin/ICTData/TestimonialsManager';
import Profile from './components/DashboardAdmin/Profile';
import IctTrainersList from './components/DashboardAdmin/ICTData/IctTrainersList';
import CoursesList from './components/DashboardAdmin/ICTData/CoursesList';
import IctCatalog from './components/DashboardAdmin/ICTData/subComponents/IctCatalog/IctCatalog'
import VendorsManager from './components/DashboardAdmin/ICTData/VendorsManager';

const user = JSON.parse(localStorage.getItem("user"));
const userRole = user?.role || null;

const protectedRoutes = [
  { path: '', element: <Dashboard />, allowedRoles: ['masterAdmin','admin','sales'] },
  { path: 'profile', element: <Profile />, allowedRoles: ['masterAdmin','admin','sales'] },
  { path: 'ict-data', element: <ICTData />, allowedRoles: ['masterAdmin','admin','sales'] },
  { path: 'ict-data/insert', element: <ICTDataInsert />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'study-modes', element: <StudyModesTable />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'study-materials', element: <StudyMaterials />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'ictdetails', element: <ICTDetails />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'ictFeedbacks', element: <ICTFeedbacks />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'ictLeads', element: <LeadsComponent />, allowedRoles: ['masterAdmin','admin','sales'] },
  { path: 'ictLearners', element: <Learners />, allowedRoles: ['masterAdmin','admin','sales'] },
  { path: 'ictLearningBundle', element: <LearningBundles />, allowedRoles: ['masterAdmin','admin','sales'] },
  { path: 'ictLearningModule', element: <LearningModules />, allowedRoles: ['masterAdmin','admin','sales'] },
  { path: 'ictRecording', element: <RecordingsManagement />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'ictTrainingCard', element: <TrainingCards />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'ictFAQManager', element: <FAQManager />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'vendorsManager', element: <VendorsManager />, allowedRoles: ['masterAdmin','admin','sales'] },
  { path: 'ictDomainManager', element: <DomainsManager />, allowedRoles: ['masterAdmin','admin','sales'] },
  { path: 'ictEmpDataManager', element: <EmployeeManager />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'ictTrainersManager', element: <TrainersManager />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'Accommodations', element: <Accommodations />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'TraveManager', element: <TravelData />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'TourData', element: <TourData />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'DCData', element: <DCData />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'ict-Catalog', element: <CoursesList />, allowedRoles: ['masterAdmin','admin','sales'] },
  { path: 'ICTSalesCard', element: <ICTSalesCard />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'ict-sales-card/receipt/:id', element: <ICTSalesCardReceiptPopup />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'MiscExpenseManager', element: <MiscExpenseManager />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'IctEnquiry', element: <IctEnquiryManager />, allowedRoles: ['masterAdmin','admin','sales'] },
  { path: 'billInvoice', element: <ICTInvoice />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'events', element: <EventsManager />, allowedRoles: ['masterAdmin','admin','sales'] },
  { path: 'testimonials', element: <TestimonialsManager />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'ictTrainersList', element: <IctTrainersList />, allowedRoles: ['masterAdmin','admin'] },
  { path: 'ict-catalog/:ictId', element: <IctCatalog />, allowedRoles: ['masterAdmin','admin','sales'] },
];

const App = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<ProtectedRoute><DashboardAdmin /></ProtectedRoute>}>
        {protectedRoutes.map(({ path, element, allowedRoles }, index) => {
          if (!allowedRoles || allowedRoles.includes(userRole)) {
            return <Route key={index} path={path} element={element} />;
          }
          return null;
        })}
      </Route>
    </Routes>
  );
};

export default App;